import PagesList from "./PagesList";

export default PagesList;
